module.exports = __webpack_public_path__ + "img/wz-4-1.075825a7.png";